<template>
  <div class="response_table role_table">
    <table>
      <thead>
        <tr>
          <th scope="col" colspan="1"> {{translate("client.role_manager.role")}} </th>
          <th scope="col" colspan="2"> {{translate("client.role_manager.permissions")}} </th>
          <th scope="col" colspan="1"> {{translate("client.role_manager.action")}} </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(role, role_key) in role_list" :key="role_key" class="role">
          <td data-label="Name" colspan="1">
            <span>{{ role.name }}</span>
          </td>

          <td data-label="Permissions" class="permissions" colspan="2">
            <span
                v-for="(permission, permission_key) in role.permissions"
                :key="permission_key"
                :title="permission_list[permission].description"
            >
              {{ permission_key !== role.permissions.length -1 ? permission + ',' : permission }}
            </span>
          </td>

          <td data-label="action" colspan="1">
             <span
                 class="action assign btn btn-success btn-wd"
                 @click="assign_role(role)"
             >
              {{ translate('btn.add') }}
            </span>

            <span
                class="action revoke btn btn-danger btn-wd"
                @click="revoke_role(role)"
            >
              {{ translate('btn.delete') }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: "ClientTableRoles",
  props: ["client_id", "role_list", "permission_list"],
  data () {
    return {

    }
  },
  methods: {
    assign_role(role){
      this.$http.v1.assignRoles({client_id: this.client_id, role: role.name}, () => {
        this.global_notify('info', this.translate('user.roles.role_assign'))
        this.$emit("update")
      })
    },
    revoke_role(role){
      this.$http.v1.revokeRoles( {client_id: this.client_id, role: role.name}, () => {
        this.global_notify('info', this.translate('user.roles.role_revoke'))
        this.$emit("update")
      })
    }
  }
}

</script>
<style lang='scss' scoped>
  .block_wrap{
    height: 100%;
  }
  .role_table{
    padding: 0;
    table{
      thead{
        flex:0;
      }
      tbody{
        .role{
          &:hover{
            background-color: #eaeaea;
          }
          .action{
            font-size: 14px;
            line-height: 100%;
            cursor: pointer;
            padding: 2px;
            margin-right: 10px;
            &:last-child{
              margin-right: 0;
            }
          }
        }
      }
    }
  }



</style>
